
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Show extends Vue {
  isShowPreview: boolean = false;
  handleStart() {
    this.isShowPreview = true;
  }
  handleNext() {
      this.$router.push('/chuan-mei-liu-yue/ShowCollege');
  }
}
